/**
 * Modal displayed once when investor authorized representative
 * completes onboarding and navigates to the note-offer-room page
 */

import { FC } from "react";
import { Modal, Text } from "@mantine/core";
import { LargeBtn, color } from "@funded-here-interface/common";

interface OnboardingCompletedModalProps {
  opened: boolean;
  onClose: () => void;
}

const OnboardingCompletedModal: FC<OnboardingCompletedModalProps> = ({
  opened,
  onClose,
}) => {
  return (
    <Modal
      centered
      size="sm"
      overlayProps={{
        blur: 3,
        opacity: 0.1,
      }}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
    >
      <div style={{ marginTop: 20, marginBottom: 5 }}>
        <Text
          style={{
            fontSize: "20px",
            fontWeight: 700,
            marginBottom: "16px",
          }}
        >
          Onboarding Completed
        </Text>
        <Text
          style={{
            fontSize: "14px",
            marginBottom: "24px",
          }}
        >
          Your onboarding process is complete. You may now start your investment
          journey.
        </Text>
        <LargeBtn
          onClick={onClose}
          backgroundColor={color.FHGREEN}
          textColor="#FFFFFF"
          width="100%"
        >
          Okay
        </LargeBtn>
      </div>
    </Modal>
  );
};

export default OnboardingCompletedModal;
